export default __webpack_public_path__ + "static/media/good_active.7a9b1c27.svg";